module.exports = __webpack_public_path__ + "img/facebook.f1c1dbd1.svg";